import styled from 'styled-components';

// Components
import { DropDownSelect } from '../../../../components/inputs/DropDown/DropDownSelect';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xl}rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    gap: ${({ theme }) => theme.spaces.m}rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet *
    theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const SubContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.xl}rem;

  /* 🔴 El contenido (todo menos el menú lateral) DEBE poder encogerse.
     Un item de flex nace con "min-width: auto", que equivale a su contenido
     mínimo, y como las celdas de las tablas llevan "white-space: nowrap" ese
     mínimo es la tabla ENTERA: en Materiales pedía 1504 px para un hueco de
     1392 y la tarjeta se salía 112 px de la pantalla (Partidas, 37). Con esto
     la tarjeta se ajusta al hueco y es el TableContainer, que ya tiene
     "overflow: auto", el que da el scroll horizontal a la tabla.
     Solo aplica por encima de smallDesktop (1860 px), que es donde esto es una
     fila; por debajo apila y el contenido ya va a ancho completo. */
  & > *:last-child {
    min-width: 0;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: 0;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 36rem;
  position: relative;
  gap: ${({ theme }) => theme.spaces.m}rem;
`;

export const DropDownSelectStyled = styled(DropDownSelect)``;
